import React, { forwardRef } from 'react'

import { Radio, RadioProps } from '@rebass/forms'

type Props = RadioProps

const SRadio = forwardRef<any, Props>((props: Props, ref) => {
    const { sx, ...otherProps } = props
    return <Radio ref={ref} sx={{ size: 33, ...sx }} {...otherProps} />
})

SRadio.displayName = 'SRadio'

export default SRadio
